import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { usersAPI } from "../api";
import { useAuth } from "../context/AuthContext";

const OAuthPage: React.FC = () => {
  const navigate = useNavigate();
  const once = useRef(false);
  const { setAuth } = useAuth();

  useEffect(() => {
    if (once.current) return;
    once.current = true;

    const params = new URLSearchParams(window.location.search);
    const access = params.get("access");
    const refresh = params.get("refresh");

    if (!access) {
      toast.error("Google token kelmadi");
      navigate("/auth", { replace: true });
      return;
    }

    (async () => {
      try {
        localStorage.setItem("token", access);
        if (refresh) localStorage.setItem("refresh_token", refresh);

        const meRes = await usersAPI.getMe();
        const me = meRes.data?.data ?? meRes.data;

        const normalizedUser = {
          id: me.id,
          fullName: me.name,
          email: me.email,
          plan: me.plan || "free",
          role: me.role,
          unique_code: me.unique_code || null,
          is_onboarded: me.is_onboarded ?? false,
        };

        setAuth(access, normalizedUser, refresh || undefined);

        window.history.replaceState({}, "", "/oauth");
      } catch (e) {
        console.error("getMe error:", e);
        // Agar getMe ishlamasa — auth o'rnatma, login sahifasiga qaytar
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        toast.error("Profil ma'lumotlarini olishda xato. Qayta kiring.");
        navigate("/auth", { replace: true });
        return;
      }

      navigate("/dashboard", { replace: true });
    })();
  }, [navigate, setAuth]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#0A0E1A",
        color: "#E2E8F0",
      }}>
      Google login...
    </div>
  );
};

export default OAuthPage;
